
import { BulletPointsColsEnum, BulletPointsCols, AnchorTargetEnum, RelValueEnum } from '@modules/design-system/types/RenderHTML.entity';

import Vue from 'vue';

export default Vue.extend({
  name: 'RenderHTML',
  props: {
    value: {
      type: String,
      required: true,
    },
    openInCurrentWindow: {
      type: Boolean,
    },
    bulletPointsCols: {
      type: Number as () => BulletPointsCols,
      default: BulletPointsColsEnum.COL_1,
      required: false,
    },
    whitespaceUnset: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    cssVars(): object {
      return {
        '--cols': this.bulletPointsCols,
      };
    },
    classObject(): object {
      return { '-whitespace-unset': this.whitespaceUnset };
    },
  },
  mounted(): void {
    if (!this.$refs.renderhtml) return;
    const links = (this.$refs.renderhtml as HTMLElement).querySelectorAll('a');
    const target = this.openInCurrentWindow ? AnchorTargetEnum.SELF : AnchorTargetEnum.BLANK;
    links.forEach(link => {
      link.target = target;
      if (!this.openInCurrentWindow) {
        link.rel = RelValueEnum.NOOPENER;
      }
    });
  },
});
